import React from 'react'
import { Formik, Form } from 'formik'
import {
    FormikControl,
    signUpInitialValues as initialValues,
    signUpSchema as validationSchema,
    FormSubmitting,
    SignUpSuccess,
    FormFailed,
    SubmitBtn,
} from '..'
import { NETLIFY_FUNCTIONS_PATH } from '../../../utils/constants'
import { navigate } from 'gatsby'
import axios from 'axios'
import { ConsentMsg } from '..'

export function SignUpForm({ siteData, isFooter }) {
    initialValues.location = siteData?.currentMetro.stores[0].salesforceValue

    const handleSubmit = async (values, helpers) => {
        try {
            helpers.setSubmitting(true)

            const formData = {
                ...values,
                updates: true,
                cloudamp__data__c: localStorage.getItem('cloudamp__data__c'),
                formType: 'newsletter',
            }

            await axios.post(`${NETLIFY_FUNCTIONS_PATH}form-handler`, formData)

            helpers.setSubmitting(false)
            helpers.setStatus('Success')

            isFooter
                ? navigate('?signup-footer#footer-top')
                : navigate('?signup-success')
        } catch (error) {
            console.error('Form submission error:', error)
            helpers.setSubmitting(false)
            helpers.setStatus('Failed')
        }
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            validateOnChange={false}
        >
            {formik => {
                return (
                    <Form className="w-100">
                        {formik.isSubmitting ? (
                            <FormSubmitting />
                        ) : formik.status === 'Success' ? (
                            <SignUpSuccess />
                        ) : formik.status === 'Failed' ? (
                            <FormFailed />
                        ) : (
                            <>
                                {/* <div className='row'> */}
                                <div className="row mb-3 text-start gx-3">
                                    <div className="col-12 col-sm-6 mb-3 mb-sm-0">
                                        <FormikControl
                                            control="input"
                                            name="first_name"
                                            placeholder="First Name*"
                                            type="text"
                                            required
                                            role="input"
                                        />
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <FormikControl
                                            control="input"
                                            name="last_name"
                                            placeholder="Last Name*"
                                            type="text"
                                            required
                                            role="input"
                                        />
                                    </div>
                                </div>
                                <div className="mb-3 text-start">
                                    <FormikControl
                                        control="emailInput"
                                        name="email"
                                        placeholder="Your Email*"
                                        required
                                        role="input"
                                    />
                                </div>
                                <div className="text-start">
                                    <FormikControl
                                        control="phoneInput"
                                        name="phone"
                                        placeholder="Phone Number*"
                                        type="tel"
                                        required
                                        role="input"
                                    />
                                </div>
                                {siteData?.currentMetro.stores.length > 1 && (
                                    <div className="mt-3">
                                        <FormikControl
                                            control="selectLocation"
                                            name="location"
                                            label="Location"
                                            milanStores={siteData.milanStores}
                                        />
                                    </div>
                                )}
                                <div className="row justify-content-center my-3">
                                    <div className="col-12 lh-1">
                                        <ConsentMsg />
                                    </div>
                                </div>

                                <div className="row mt-1">
                                    <div className="col-12 text-center">
                                        <SubmitBtn formik={formik} />
                                    </div>
                                </div>
                            </>
                        )}
                    </Form>
                )
            }}
        </Formik>
    )
}

export default SignUpForm
